import { render } from "./ProfileCreate.vue?vue&type=template&id=956ba6e2"
import script from "./ProfileCreate.vue?vue&type=script&lang=js"
export * from "./ProfileCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__